import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { User } from '../_models/user';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Association } from 'app/_models/association';
import { dirtyParentQueries } from '@angular/core/src/view/query';

@Injectable()
export class AuthenticationService extends ApiService {
  constructor(private http: Http) {
    super('api/token-auth/', http);
  }

  login(user: User): Observable<boolean> {
    return this.http
      .post(this.apiUrl + this.endpointUrl, JSON.stringify({ username: user.username, password: user.password, platform: 'deo' }), {
        headers: this.authHeaders,
      })
      .map((response: Response) => {
        const token = response.json() && response.json().token;
        const associationAccess = response.json() && response.json().association_access;

        if (token) {
          localStorage.setItem('currentUser', JSON.stringify({ username: user.username, token: token }));

          if (associationAccess && associationAccess.length > 0) {
            const associations: Association[] = [];
            associationAccess.map((association) => {
              associations.push(association);
            });

            localStorage.setItem('associationAccess', JSON.stringify(associations));
            this.setXAssociation(associations[0].id);
          }

          // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      })
      .catch(this.handleError);
  }

  logout(): void {
    ['currentUser', 'profile', 'associationAccess', 'x-association'].forEach((item) => localStorage.removeItem(item));
  }

  public getAccessData(): object[] {
    return JSON.parse(localStorage.getItem('associationAccess')) || [];
  }

  public getXAssociation() {
    return localStorage.getItem('x-association');
  }

  public setXAssociation(id: number) {
    localStorage.setItem('x-association', `${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts